__turbopack_context__.v({
  "container": "fetch-error-message-module__cJvpBW__container",
  "tryAgain": "fetch-error-message-module__cJvpBW__tryAgain",
});
